import axios from "axios";
import { HOST } from "config/config";
import tableDataQueryStringBuilder from "utils/tableData";

export function getCategories(tableDataParam, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().categoriesReducer.updating || forceRefresh) {
      if (tableDataParam === undefined) {
        return dispatch({
          type: "GET_CATEGORIES_PENDING",
          payload: axios
            .get(`${HOST}/api/categories`)
            .then(response => response.data)
            .then(json =>
              dispatch({
                type: "GET_CATEGORIES_FULFILLED",
                payload: {
                  items: json
                }
              })
            )
            .catch(error =>
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.message
                }
              })
            )
        });
      }

      return dispatch({
        type: "GET_CATEGORIES_PENDING",
        payload: axios
          .get(`${HOST}/api/categories`, {
            paramsSerializer: params => tableDataQueryStringBuilder(params),
            params: tableDataParam
          })
          .then(response => response.data)
          .then(json => {
            if (tableDataParam) {
              dispatch({
                type: "UPDATE_CATEGORIES_TABLEDATAPARAM",
                payload: tableDataParam
              });
            }

            dispatch({
              type: "GET_CATEGORIES_FULFILLED",
              payload: json
            });
          })
          .catch(error =>
            dispatch({
              type: "GET_CATEGORIES_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function getCategoriesForSelect() {
  return (dispatch, getState) => {
    if (!getState().categoriesReducer.updating) {
      return dispatch({
        type: "GET_CATEGORIES_PENDING",
        payload: axios
          .get(`${HOST}/api/categories`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_CATEGORIES_SELECT_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "SHOW_MESSAGE",
              payload: {
                type: "error",
                titleKey: "error",
                message: error.message
              }
            })
          )
      });
    }
  };
}

export function getCategory(categoryId, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().categoriesReducer.updating || forceRefresh) {
      if (categoryId === 0) {
        return dispatch({
          type: "GET_CATEGORY_FULFILLED",
          payload: {
            id: 0,
            internalName: "",
            nameFrench: "",
            nameEnglish: "",
            createdDate: new Date()
          }
        });
      }
      return dispatch({
        type: "GET_CATEGORY_PENDING",
        payload: axios
          .get(`${HOST}/api/categories/${categoryId}`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_CATEGORY_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "GET_CATEGORY_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function updateCategory(category) {
  return dispatch =>
    dispatch({
      type: "UPDATE_CATEGORY",
      payload: category
    });
}

export function persistCategory(category) {
  return (dispatch, getState) => {
    if (!getState().categoriesReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: "PERSISTING_CATEGORY",
          payload: (category.id === 0
            ? axios.post(`${HOST}/api/categories`, category)
            : axios.put(`${HOST}/api/categories/${category.id}`, category)
          )
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: "PERSISTED_CATEGORY",
                payload: {
                  category: json,
                  isNew: category.id === 0
                }
              });

              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "success",
                  titleKey: "success",
                  messageKey: "saved_successful"
                }
              });
              return resolve();
            })
            .catch(error => {
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.response
                }
              });
              return reject();
            })
        })
      );
    }
  };
}
